import { useRef } from 'react'
import { Box, Typography, Modal, IconButton, Stack } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined'
import { PanZoom } from 'react-easy-panzoom'
import IssueLayer from './IssueLayer'

const BlockScreenshotModal = ({ openBlockModal, handleBlockModalClose, fullPageBlock, selectedSection, selectedIssue }) => {
  const panZoomRef = useRef(null)

  const handleZoomIn = () => {
    if (panZoomRef.current) {
      panZoomRef.current.zoomIn(5)
    }
  }

  const handleZoomOut = () => {
    if (panZoomRef.current) {
      panZoomRef.current.zoomOut(3.77)
    }
  }

  const handleReset = () => {
    if (panZoomRef.current) {
      panZoomRef.current.reset()
    }
  }

  return (
    <Modal
      className="uiTestingPageSectionModal"
      open={openBlockModal}
      onClose={handleBlockModalClose}
    >
      <Box className="uiTestingPageSectionContent">
        <Typography className="uiTestingPageSectionTitle">
          { fullPageBlock?.id === selectedSection?.id
            ? 'Full Page Screenshot'
            : 'Page Section Screenshot'
          }
        </Typography>
        <IconButton className="uiTestingPageSectionCloseButton" onClick={handleBlockModalClose}>
          <CloseIcon />
        </IconButton>
        <Box className="uiTestingPageSectionImageContainer">
          <PanZoom
            ref={panZoomRef}
            className="uiTestingPageSectionPanZoomContainer"
          >
            <Box>
              <img
                className="uiTestingPageSectionImage"
                src={selectedSection?.img_storage_link}
                alt="Section Screenshot"
              />
              {selectedIssue &&
                <IssueLayer
                  top={selectedIssue.b_box_relative_top}
                  right={selectedIssue.b_box_relative_right}
                  bottom={selectedIssue.b_box_relative_bottom}
                  left={selectedIssue.b_box_relative_left}
                />
              }
            </Box>
          </PanZoom>
        </Box>
        <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
          <IconButton className="zoomIconButton" onClick={handleZoomIn}>
            <AddIcon />
          </IconButton>
          <IconButton className="zoomIconButton" onClick={handleZoomOut}>
            <RemoveIcon />
          </IconButton>
          <IconButton className="zoomIconButton" onClick={handleReset}>
            <BlockOutlinedIcon />
          </IconButton>
        </Stack>
      </Box>
    </Modal>
  )
}

export default BlockScreenshotModal
